import React, {
  Fragment,
  useEffect,
  useContext,
  useState,
  useRef,
} from "react";
import { Route, Switch, useLocation, useHistory } from "react-router-dom";
import NavBar from "./components/layout/NavBar";
import Gallery from "./components/layout/Gallery";
import HomeLayout from "./components/layout/HomeLayout";
import FooterContent from "./components/layout/Footer";
import Alerts from "./components/layout/Alerts";
import PrivateRoute from "./components/routing/PrivateRoute";
import setAuthToken from "./utils/setAuthToken";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.css";
// import "./css/style-old.css";
import Cards from "./components/cards/Cards";
import CardDetail from "./components/cards/CardDetail";
import ConfigContext from "./context/config/ConfigContext";
import AlertContext from "./context/alert/AlertContext";
import Account from "./components/user/Account";
import ForgotPassword from "./components/user/ForgotPassword";
import ResetPasswordLink from "./components/user/ResetPasswordLink";
import ResetPassword from "./components/user/ResetPassword";
import InitRecharge from "./components/user/InitRecharge";
import ConfirmCard from "./components/user/ConfirmCard";
import UnregRechargeValue from "./components/user/UnregRechargeValue";
import Cart from "./components/cart/Cart";
import PatronCart from "./components/cart/PatronCart";
import BillingOrder from "./components/common/BillingOrder";
import PatronBillingOrder from "./components/common/PatronBillingOrder";
import Billing from "./components/common/Billing";
import OrderConfirmation from "./components/common/OrderConfirmation";
import PatronOrderConfirmation from "./components/common/PatronOrderConfirmation";
import RechargeCard from "./components/recharge/RechargeCard";
import SubscribeCard from "./components/user/SubscribeCard";
import OrderHistory from "./components/order/OrderHistory";
import OrderDetails from "./components/order/OrderDetails";
import GroupManagement from "./components/sponsor/GroupManagement";
import Group from "./components/sponsor/Group";
import EmployeeManagement from "./components/sponsor/EmployeeManagement";
import CompCardManagement from "./components/sponsor/CompCardManagement";
import Employee from "./components/sponsor/Employee";
import CardAllocation from "./components/sponsor/CardAllocation";
import PatronSubscribe from "./components/user/PatronSubscribe";
import ContractDetail from "./components/sponsor/ContractDetail";
import UserFeedback from "./components/common/UserFeedback";
import useIdleTimer from "./hooks/useIdleTimer";
import AuthContext from "./context/auth/AuthContext";

if (localStorage.getItem("token")) {
  setAuthToken(localStorage.getItem("token"));
}

function App() {
  const configContext = useContext(ConfigContext);
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const [isLocation, setIsLocation] = useState(false);
  //eslint-disable-next-line
  const [appTitle, setAppTitle] = useState(
    "Reload Your METRO Q Fare Card or METRO Day Pass | Houston, Texas"
  );
  const location = useLocation();
  const history = useHistory();

  const { setAlert, clearAlerts } = alertContext;
  const { error } = configContext;

  const { IdleModalDialog, resetUseIdleTimer } = useIdleTimer();

  let mainContentRef = useRef(null);

  const focusOnMain = () => {
    console.log(
      "mainContentRef",
      mainContentRef,
      mainContentRef.current.focus()
    );
    mainContentRef.current.focus();
  };

  useEffect(() => {
    if (
      location.pathname === "/unreg-recharge" ||
      location.pathname === "/account" ||
      location.pathname === "/" ||
      location.pathname === "/forgot-password" ||
      location.pathname === "/reset-link"
    ) {
      setIsLocation(true);
    } else {
      setIsLocation(false);
    }
    if (location.pathname === "/" && user && user.id) {
      history.replace("/account");
    }
    //eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    if (error) {
      clearAlerts();
      let errMsg = error.response.message;
      console.log("Error::::", JSON.stringify(error));
      setAlert(errMsg, "danger");
    }
    // const getConfigDetails = async () => {
    //   await loadConfig();
    // };

    // if (!loading && !loaded) {
    //   getConfigDetails();
    //   console.log("CONFIG LOADED");
    // }

    //eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div className="main-container">
        <div className="header">
          <NavBar focusOnMain={focusOnMain} />
        </div>
        {isLocation && (
          <div className="gallery">
            <Gallery />
          </div>
        )}
        <div className="notice-bar">
          <Alerts role="alert" aria-relevant="all" />
        </div>
        <IdleModalDialog />
        <Switch>
          <Route exact path="/forgot-password">
            <ForgotPassword
              appTitle={appTitle}
              mainContentRef={mainContentRef}
            />
          </Route>
          <Route exact path="/reset-link">
            <ResetPasswordLink
              appTitle={appTitle}
              mainContentRef={mainContentRef}
            />
          </Route>
          {/* <Route
            exact
            path="/reset-password/:reset_token"
            component={ResetPassword}
          /> */}
          <Route exact path="/user/isTokenValid">
            <ResetPassword
              appTitle={appTitle}
              mainContentRef={mainContentRef}
            />
          </Route>
          <Route exact path="/unreg-recharge">
            <InitRecharge appTitle={appTitle} mainContentRef={mainContentRef} />
          </Route>
          <Route exact path="/unreg-recharge-card">
            <ConfirmCard appTitle={appTitle} mainContentRef={mainContentRef} />
          </Route>
          <Route exact path="/unreg-recharge-value">
            <UnregRechargeValue
              appTitle={appTitle}
              mainContentRef={mainContentRef}
            />
          </Route>
          <Route exact path="/unreg-cart">
            <Cart appTitle={appTitle} mainContentRef={mainContentRef} />
          </Route>
          <Route exact path="/billing">
            <BillingOrder appTitle={appTitle} mainContentRef={mainContentRef} />
          </Route>
          <Route exact path="/confirm-order">
            <OrderConfirmation
              appTitle={appTitle}
              mainContentRef={mainContentRef}
            />
          </Route>
          <Route exact path="/user-feedback">
            <UserFeedback appTitle={appTitle} mainContentRef={mainContentRef} />
          </Route>
          <PrivateRoute
            exact
            path="/cards"
            component={Cards}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/group_mgmt"
            component={GroupManagement}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/group-detail"
            component={Group}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/emp_mgmt"
            component={EmployeeManagement}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/create-employee"
            component={CardAllocation}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/employee-detail"
            component={Employee}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/company_mgmt"
            component={CompCardManagement}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/home/mycard-details"
            component={CardDetail}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/recharge/:actionType"
            component={RechargeCard}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/user-cart"
            component={PatronCart}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/patron-billing"
            component={PatronBillingOrder}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/subscribe-billing"
            component={Billing}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/user-confirm-order"
            component={PatronOrderConfirmation}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/subscribe/:actionType"
            component={SubscribeCard}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/single-subscribe"
            component={PatronSubscribe}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/contract-detail"
            component={ContractDetail}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/account"
            component={Account}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/order"
            component={OrderHistory}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <PrivateRoute
            exact
            path="/order-detail"
            component={OrderDetails}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
          <Route exact path="/">
            <HomeLayout appTitle={appTitle} mainContentRef={mainContentRef} />
          </Route>
        </Switch>

        <div className="footer">
          <FooterContent />
        </div>
      </div>
    </Fragment>
  );
}

export default App;
